enum DialogType {
    None,
    CautionTabChangePopup,
    CautionShortCutPopup,
    CautionMultiMonitorPopup,

    CookieAccept,
    ContestAuthentication,
    CheatingMultiMonitorCheck,
    CheatingScreenRecordingAgree,
    TrackGuideViewPopup,
    CandidateTimeLinePopup,
    CandidateSlidePopup,
    ProSkillAssureSamplePopup,
    TrackDescriptionPopup,
    LearningConfirmPopup,
    LearningDirectoryRollback,
    LearningSampleAssessmentInfoPopup,
    TrackLevelGuidePopup,
    SendInvitationPopup,
    ProSkillAssureCandidatesDelete,
    ProSkillAssureAssessmentDelete,
    ResendEmailPopup,
    ProSkillAssureSlidePopup,
    ProfileAboutMeInformationPopup,
    ProfileWorkExperienceInformationPopup,
    ProfileEducationInformationPopup,
    ProfileBasicInformationPopup,
    ProfilePersonalInformationPopup,
    ProfileSkillsInformationPopup,
    ProfileTrackLevelInformationPopup,
    RecordingFullScreenPopup,
    AgreeDeleteAccount,
    PasswordChangePopup,
    OrganizationLeaveConfirmPopup,
    OrganizationCreatePopup,
    OrganizationMemberInvited,
    OrganizationMemberModify,
    OrganizationMemberDelete,
    OrganizationMemberTransferAuthority,
    OrganizationSubscribeCancelPopup,
    OrganizationSubscribeRestartPopup,
    GuidelinePopup,
    ProSkillAssureDurationGuidePopup,
    ProSkillAssureTemplateSave,
    ProSkillAssureTemplateManage,
    DesktopAppInstallPopup,
    ProctiveRecordingFailPopup,

    ProctiveScreenPermissionGuidePopup,

    // ASMT-PROCTOR-14 / -15 (REQ-313): 응시 환경 사전 점검 실패 안내
    AssessmentScreenShareHelpPopup,
    ProctiveEnvironmentHelpPopup,

    ReportEnterEmailPopup,
    ReportBulkEnterEmailPopup,
    GenericAlert,
    GenericConfirm,
    OrganizationAddCreditsPopup,
    OrganizationCardChangePopup,

    // #2260: AccessToken died mid-exam — answers kept, log in again and continue
    SessionExpired
}

export default DialogType;
